import { MenuRoute } from '../../../shared/menu/menu-route.model';

/**
 * Menu-eligible routes exposed by the FixedAsset core sub-module.
 */
export const FIXED_ASSET_MENU_ROUTES: MenuRoute[] = [
  {
    path: '/fixed-asset/display-fixed-asset',
    labelKey: 'FixedAsset.displayFixedAsset',
    icon: '/assets/tablerIcons/outline/building-warehouse.svg',
    moduleId: 26,
    groupLabelKey: 'MenuRoutes.group.fixedAssetViews'
  },
  {
    path: '/fixed-asset/display-project',
    labelKey: 'FixedAsset.displayProject',
    icon: '/assets/tablerIcons/outline/folder-open.svg',
    moduleId: 26,
    groupLabelKey: 'MenuRoutes.group.fixedAssetViews'
  },
  {
    path: '/fixed-asset/layout',
    labelKey: 'FixedAsset.layout',
    icon: '/assets/tablerIcons/outline/layout-grid.svg',
    moduleId: 26,
    groupLabelKey: 'MenuRoutes.group.fixedAssetViews'
  },
  {
    path: '/fixed-asset/nis-disposal',
    labelKey: 'FixedAsset.nisDisposal',
    icon: '/assets/tablerIcons/outline/trash.svg',
    moduleId: 26,
    groupLabelKey: 'MenuRoutes.group.fixedAssetTools'
  }
];
